export enum DiscussionParticipantFlagType {
  NotEngaged = 1,
  NotReal = 2,
  NotUnique = 3
}
